import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from '../navbar/navbar.component';
import { NavbarService } from '../navbar/navbar.service';

@Component({
    selector: 'app-layout',
    imports: [RouterOutlet, NavbarComponent],
    styles: ['main {margin: 1rem}'],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-navbar>
      <main>
        <router-outlet></router-outlet>
      </main>
    </app-navbar>
  `
})
export class LayoutComponent {
  constructor() {
    inject(NavbarService).initializeNavbarService();
  }
}